import React, { useState, useEffect } from "react";
import { Card, Form, Typography, Checkbox, Button } from "antd";
import CheckboxBtn from "../CheckboxBtn";
import "./CheckboxGroup.scss";

const { Title } = Typography;

export default function CheckboxGroup({
  checkboxData,
  onSubmit,
  ...otherProps
}) {
  const [checkBoxList, setCheckBoxList] = useState([]);

  const setAllCheckBoxUnchecked = () => {
    setCheckBoxList(Array(checkboxData.items.length).fill(false));
  };

  const handleChecked = (e) => {
    const arr = [...checkBoxList];
    arr[e.target.getAttribute("data-id")] =
      !arr[e.target.getAttribute("data-id")];
    setCheckBoxList(arr);
    onSubmit(mapData(arr));
  };

  const mapData = (dataList) => {
    const data = [];
    for (let i = 0; i <= dataList.length - 1; i++) {
      data.push({
        value: checkboxData.items[i].value,
        checked: dataList[i],
      });
    }
    return data;
  };

  useEffect(() => {
    if (checkboxData.items.length !== 0) {
      setAllCheckBoxUnchecked();
    }

    if(checkboxData?.formData?.name === 'getDiscountWay') {
      const session = JSON.parse(sessionStorage.getItem('register2'));

      if (session?.gettingDiscountWay) {
        const splits = session?.gettingDiscountWay
          .split(/(\d)/)
          .filter((slice) => slice);
        const optionArr = [];

        splits.forEach((item, index) => {
          if (Number(item) || Number(item) === 0) {
            Number(item) !== 0 ? (optionArr.push(true)) : (optionArr.push(false));
          }
        });
        setCheckBoxList(optionArr);
      } else {
        setCheckBoxList(prev => prev.fill(true));
      }
    }
  }, [checkboxData.items]);

  const groupItems = checkboxData.items.map((groupItem, index) => {
    return (
      <CheckboxBtn
        label={groupItem.label}
        value={groupItem.value}
        isChecked={checkBoxList[index]}
        itemIndex={index}
        key={index}
        handleChecked={handleChecked}
      ></CheckboxBtn>
    );
  });
  return (
    <Card className="group-wrapper">
      <Title level={4}>{checkboxData.title}</Title>
      {groupItems}
    </Card>
  );
}
